export const build = {"tag":"v1.0.7","hash":"9353f88f","time":"261105.1036"}